import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

export default function useClickOutside(
  ref: RefObject<HTMLElement | null | undefined>,
  callback: (event: MouseEvent | TouchEvent) => void,
  eventType: 'click' | 'default' = 'default',
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handler = (event: MouseEvent | TouchEvent) => {
      const element = ref.current;

      if (element && !element.contains(event.target as Node)) {
        callbackRef.current(event);
      }
    };

    if (eventType === 'click') {
      document.addEventListener('click', handler);

      return () => {
        document.removeEventListener('click', handler);
      };
    }

    document.addEventListener('mousedown', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventType]);
}
